export default __webpack_public_path__ + "a96a04368939933c2153f112649626c0.jpg";